/* Rendering month & year selector */
import React from "react";
import moment from "moment";
import { useSelector } from "react-redux";
import { Box, Button } from "@mui/material";

import { getButtonBgColor, getFontFamily } from "slices";
import { Icon } from "components";

const TopBox = ({ focusedDate, showType, setShowType, setFocusedDate }) => {
  const color = useSelector(getButtonBgColor);
  const fontFamily = useSelector(getFontFamily);

  return (
    <div className="hayley-col-span-7 hayley-flex hayley-h-9 hayley-min-w-[252px] hayley-items-center hayley-justify-between">
      <div className="hayley-flex hayley-items-center hayley-space-x-2">
        <Box
          data-testid="calendar-months"
          className="hayley-custom hayley-flex hayley-cursor-pointer hayley-items-center hayley-text-secondary"
          sx={{ "&.hayley-custom": { fontFamily: `${fontFamily} !important`, "&:hover": { color: `${color} !important` } } }}
          onClick={() => setShowType((prev) => (prev === "day" ? "month" : "day"))}
        >
          <span className="hayley-text-sm hayley-font-semibold">{moment.months()[focusedDate.month()]}</span>
          <Icon iconType="Chevron" className={`hayley-h-5 hayley-w-5 hayley-text-inherit ${showType === "month" ? "-hayley-rotate-90" : "hayley-rotate-90"}`} />
        </Box>
        <Box
          data-testid="calendar-year"
          className="hayley-custom hayley-flex hayley-cursor-pointer hayley-items-center hayley-text-secondary"
          sx={{ "&.hayley-custom": { fontFamily: `${fontFamily} !important`, "&:hover": { color: `${color} !important` } } }}
          onClick={() => setShowType((prev) => (prev === "day" ? "year" : "day"))}
        >
          <span className="hayley-text-sm hayley-font-semibold">{focusedDate.year()}</span>
          <Icon iconType="Chevron" className={`hayley-h-5 hayley-w-5 hayley-text-inherit ${showType === "year" ? "-hayley-rotate-90" : "hayley-rotate-90"}`} />
        </Box>
      </div>

      <div className="hayley-col-span-3 hayley-flex hayley-h-9 hayley-items-center hayley-justify-end">
        <Button
          className="hayley-custom hayley-h-fit hayley-min-h-min hayley-w-fit hayley-min-w-min hayley-cursor-pointer hayley-rounded-none hayley-border-none hayley-bg-transparent hayley-text-secondary"
          sx={{ "&.hayley-custom": { "&:hover": { color: `${color} !important` } } }}
          onClick={() => setFocusedDate(focusedDate.clone().subtract(1, "month"))}
        >
          <Icon iconType="Chevron" className="hayley-h-5 hayley-w-5 hayley-rotate-180 hayley-text-inherit" />
        </Button>
        <Button
          className="hayley-custom hayley-h-fit hayley-min-h-min hayley-w-fit hayley-min-w-min hayley-cursor-pointer hayley-rounded-none hayley-border-none hayley-bg-transparent hayley-text-secondary"
          sx={{ "&.hayley-custom": { "&:hover": { color: `${color} !important` } } }}
          onClick={() => setFocusedDate(moment())}
        >
          <Icon iconType="CalToday" className="hayley-h-3 hayley-w-3 hayley-text-inherit" />
        </Button>
        <Button
          className="hayley-custom hayley-h-fit hayley-min-h-min hayley-w-fit hayley-min-w-min hayley-cursor-pointer hayley-rounded-none hayley-border-none hayley-bg-transparent hayley-text-secondary"
          sx={{ "&.hayley-custom": { "&:hover": { color: `${color} !important` } } }}
          onClick={() => setFocusedDate(focusedDate.clone().add(1, "month"))}
        >
          <Icon iconType="Chevron" className="hayley-h-5 hayley-w-5 hayley-text-inherit" />
        </Button>
      </div>
    </div>
  );
};

export default TopBox;
